// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Fragment } from 'react'

import loadable from '@loadable/component'
import { Container } from '../helpers/react'

const Unsubscribe = loadable(() => import('./unsubscribe/index'))
const ProvidersList = loadable(() => import('./providers-list-wrapper'))
const CreditCardCalculator = loadable(() => import('./calculators/credit-card-calculator'))
const UswitchCreditCardCalculator = loadable(
  () => import('./calculators/compounds/uswitch-credit-card-calculator'),
)
const PensionsCalculator = loadable(() => import('./calculators/pensions-calculator'))
const PensionsDrawdownCalculator = loadable(
  () => import('./calculators/pensions-drawdown-calculator'),
)
const PensionsPayoutCalculator = loadable(() => import('./calculators/pensions-payout-calculator'))

const PoweredByMojoTrustpilot = loadable(() => import('./powered-by-mojo-trustpilot'))

const ResultsCard = loadable(() => import('./results-card'))

const COMPONENTS = {
  CreditCardCalculator,
  PensionsCalculator,
  PensionsDrawdownCalculator,
  PensionsPayoutCalculator,
  PoweredByMojoTrustpilot,
  ProvidersList,
  ResultsCard,
  Unsubscribe,
  UswitchCreditCardCalculator,
}

const Component = ({ component, container = false, options = {}, ...rest }) => {
  const C = COMPONENTS[component] || Fragment
  /* eslint-disable camelcase */
  const dataClickTracking = {
    component_category: 'component',
    component_id: rest.sys?.id,
    component_name: component,
    contentful_name: rest.name,
    contentful_variant: component,
  }
  return (
    <Choose>
      <When condition={container}>
        <Container>
          <C {...options} sys={rest.sys} dataClickTracking={dataClickTracking} {...rest} />
        </Container>
      </When>

      <Otherwise>
        <C {...options} sys={rest.sys} {...rest} />
      </Otherwise>
    </Choose>
  )
}

export default Component
